<template>
    <span
        class="svg-img"
        ref="svg_wrapper"
        v-on:mouseenter="hovering = true"
        v-on:mouseleave="hovering = false"
        v-bind:class="{'cursor-pointer': auto_hover}"
        v-on:click="$emit('click')"
    >
        <slot></slot>
    </span>
</template>

<script>
    let loaded = {
        svgs      : {},
        callbacks : {}
    }

    export default {
        name: "SVGImage",
        props: {
            src: {
                type: String,
                validator: function (value) {
                    if(!value) return true;
                    // Check the path contains "/svg/" and ends in ".svg"
                    return /svg\//.test(value) && /\.svg$/.test(value);
                }
            },

            svg_name: {
                type: String,
                validator: function (value) {
                    if (!value) return true;

                    // Check the path does not contain "svg/" and does not end with ".svg"
                    return !(/svg\//.test(value) && /\.svg$/.test(value));
                },
            },

            //colors
            color: {
                type: String,
                default: 'dark'
            },
            highlight: {
                type: String,
                default: 'primary'
            },

            //size
            width: {
                type: String,
                default: null
            },
            height: {
                type: String,
                default: null
            },

            //highlight effects
            active: {
                type: Boolean,
                default: false
            },
            hover: {
                type: Boolean,
                default: false
            },
            auto_hover: {
                type: Boolean,
                default: false
            },
            spaced: {
                type: Boolean,
                default: false
            }
        },

        data(){
            return {
                highlighted: false,
                hovering: false,

                svgElement: null,

                fillElements: [],
                strokeElements: [],
            }
        },

        mounted() {
            this.highlighted = this.hover || this.active;
            this.getElement();

            if (this.src && this.svg_name) {
                console.error('Prop error in SVGImage.vue: Either use src or svg_name, not both. The src prop has priority.');
            } else if( !this.src && !this.svg_name) {
                console.error('Prop error in SVGImage.vue: You must provide either the src or svg_name');
            }
        },

        methods: {
            download: async function(){
                if(loaded.svgs[this.srcPath] === undefined){
                    loaded.svgs[this.srcPath] = null
                    loaded.callbacks[this.srcPath] = []

                    const response = await axios.get(this.srcPath)

                    loaded.svgs[this.srcPath] = response.data

                    loaded.callbacks[this.srcPath].forEach((callback) => callback(response.data))
                    delete loaded.callbacks[this.srcPath]
                }

                if(loaded.svgs[this.srcPath] === null){
                    return new Promise((resolve) => {
                        loaded.callbacks[this.srcPath].push(
                            (svg) => resolve(svg)
                        )
                    })
                }

                return loaded.svgs[this.srcPath]
            },

            getElement: async function (){
                const svg = await this.download()

                this.$refs.svg_wrapper.innerHTML = svg + this.$refs.svg_wrapper.innerHTML;
                const svgElement = this.$refs.svg_wrapper.children[0];

                if (this.spaced) {
                    svgElement.classList.add('svg-img--spaced');
                }

                this.svgElement = svgElement;

                let fills = [...svgElement.querySelectorAll('[fill]')].filter((el) => el.getAttribute('fill') !== 'none');
                let strokes = [...svgElement.querySelectorAll('[stroke]')].filter((el) => el.getAttribute('stroke') !== 'none');

                let colors = fills.map((el) => el.getAttribute('fill'))
                    .concat(strokes.map((el) => el.getAttribute('stroke')));

                let main_color = this.getMostCommonColor(colors);

                this.fillElements = fills.filter((el) => el.getAttribute('fill') === main_color);
                this.strokeElements = strokes.filter((el) => el.getAttribute('stroke') === main_color);

                this.setColor();
                this.setSize();
            },

            getMostCommonColor(colors){
                if (colors.length === 0) return null;
                if (colors.length === 1) return colors[0];

                colors.sort();
                let max = 0;
                let freq = 0;
                let result = undefined;

                for(let i = 0; i < colors.length; i++){
                    if(colors[i] === colors[i + 1]) freq++;
                    else freq = 0;

                    if(freq > max){
                        result = colors[i];
                        max = freq;
                    }
                }

                return result;
            },

            setColor(){
                const color = this.highlighted ? this.processedHighlightColor : this.processedColor;
                this.fillElements.forEach((element) => element.setAttribute('fill', color));
                this.strokeElements.forEach((element) => element.setAttribute('stroke', color));
            },

            setSize(){
                if (!this.svgElement) return;
                if (this.width) this.svgElement.setAttribute('width', this.width);
                if (this.height) this.svgElement.setAttribute('height', this.height);
            },
        },

        computed: {
            processedColor(){
                const main_color = getComputedStyle(document.documentElement).getPropertyValue('--' + this.color);
                if (main_color) return main_color;
                else return this.color;
            },
            processedHighlightColor(){
                const main_color = getComputedStyle(document.documentElement).getPropertyValue('--' + this.highlight);
                if (main_color) return main_color;
                else return this.color;
            },

            srcPath() {
                if (this.src) {
                    return this.src;
                } else {
                    return `/svg/${resource_group}/${this.svg_name}.svg`;
                }
            },
        },

        watch: {
            hovering(){
                if (this.auto_hover)
                    this.highlighted = this.hovering;
            },
            hover(){
                this.highlighted = this.hover || this.active;
            },
            active(){
                this.highlighted = this.hover || this.active;
            },
            highlighted(){
                this.setColor();
            },
            width(){
                this.setSize();
            },
            height(){
                this.setSize();
            }
        }
    }
</script>
